import { render, staticRenderFns } from "./PlatformSection.vue?vue&type=template&id=6901a719&scoped=true"
import script from "./PlatformSection.vue?vue&type=script&lang=js"
export * from "./PlatformSection.vue?vue&type=script&lang=js"
import style0 from "./PlatformSection.vue?vue&type=style&index=0&id=6901a719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6901a719",
  null
  
)

export default component.exports